import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TransactionBuilderModule } from './transaction-builder/transaction-builder.module';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MockApiInterceptor } from '@app/core/interceptors/mock-api.interceptor';
import { SharedModule } from './shared/shared.module';
import { CustomTranslationLoaderService, OidcAuthGuard } from 'ngx-mat-esign360';
import { InitializerService } from '@app/core/services/initializer.service';
import { KeycloakAngularModule, KeycloakAuthGuard } from 'keycloak-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LayoutModule } from '../app/layout/layout.module';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new CustomTranslationLoaderService(http);
}

export function initializeApp(initializer: InitializerService) {
  return (): Promise<any> => initializer.init();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TransactionBuilderModule,
    SharedModule,
    KeycloakAngularModule,
    LayoutModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: KeycloakAuthGuard, useClass: OidcAuthGuard },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MockApiInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [InitializerService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
